/**
 * FIFINE MX - Sincroniza la miniatura activa con la galeria
 * ---------------------------------------------------------------------------
 * La galeria ya funciona sin este script: las miniaturas son anclas y el
 * desplazamiento lo hace el navegador. Esto solo mueve el borde de "activa"
 * a la miniatura que corresponde a la imagen visible, que es feedback puro.
 *
 * Se carga como type="module": aunque varias secciones lo pidan, el navegador
 * lo ejecuta una sola vez por URL.
 */

const TRACK = '.fif-gallery__track';
const SLIDE = '.fif-gallery__slide';
const THUMB = '.fif-thumb';
const ACTIVE = 'is-active';

/** @type {WeakSet<Element>} */
const wired = new WeakSet();

/**
 * @param {Element} gallery Contenedor .fif-gallery
 */
function wire(gallery) {
  if (wired.has(gallery)) return;

  const track = gallery.querySelector(TRACK);
  const thumbs = [...gallery.querySelectorAll(THUMB)];
  if (!track || thumbs.length === 0) return;

  const slides = [...track.querySelectorAll(SLIDE)];
  if (slides.length === 0) return;

  wired.add(gallery);

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const i = slides.indexOf(entry.target);
        // Puede haber mas imagenes que miniaturas (thumb_count las limita).
        if (i < 0 || i >= thumbs.length) continue;
        thumbs.forEach((t, n) => t.classList.toggle(ACTIVE, n === i));
      }
    },
    { root: track, threshold: 0.6 }
  );

  slides.forEach((slide) => io.observe(slide));
}

function init(root) {
  (root || document).querySelectorAll('.fif-gallery').forEach(wire);
}

if ('IntersectionObserver' in window) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  // El theme editor monta y remonta secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', (event) => {
    init(/** @type {any} */ (event).target);
  });
}
